module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16zIKlM/media/FC-9781398468719.jpg?1684514594578",
      "alt": "This image is the cover for the book Loving Leadership"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Loving Leadership\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("When leadership is powered by love, it can change everything… In his second book, Michael Quigley presents a radical new model for leading using love as the driving force for your leadership. Michael will guide you in the six key practices of a loving leader: how to let go of enemies, grow and develop, embrace paradoxes, enjoy sacred relationships, think long-term, and produce meaning that truly matters. This book contains a combination of inspirational true stories from the worlds of business and education, as well as key insights, unique strategies and frameworks – which you won’t find anywhere else. By combining the material in this book with the love in your heart you can become a true loving leader. Our world deserves a better kind of leader – are you ready to become one?")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Michael Quigley\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Michael Quigley BA Hons 1st class MA, PGCE, is a former primary school teacher with extensive experience in teaching, coaching, mentoring and leadership. His company Kataholos has the mission of growing people to be their best selves with clients all over the world. Michael has a motivational podcast, Food for the Journey, as well as blogs and videos available to inspire and empower people from all walks of life. Michael loves to keep fit and play music, as well as travel and learn new skills. Loving Leadership is Michael’s second published book.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0